import { useEffect } from 'react';
function useScrollDrag(container, enabled) {
    useEffect(function () {
        if (!enabled) {
            return;
        }
        var slider = container.current;
        var isDown = false;
        var startX = 0;
        var scrollLeft = 0;
        var mouseDown = function (e) {
            if (slider) {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            }
        };
        var mouseLeave = function () {
            isDown = false;
        };
        var mouseUp = function () {
            isDown = false;
        };
        var mouseMove = function (e) {
            if (slider) {
                if (!isDown)
                    return;
                e.preventDefault();
                var x = e.pageX - slider.offsetLeft;
                var walk = (x - startX) * 1;
                slider.scrollLeft = scrollLeft - walk;
            }
        };
        slider === null || slider === void 0 ? void 0 : slider.addEventListener('mousedown', mouseDown);
        slider === null || slider === void 0 ? void 0 : slider.addEventListener('mouseleave', mouseLeave);
        slider === null || slider === void 0 ? void 0 : slider.addEventListener('mouseup', mouseUp);
        slider === null || slider === void 0 ? void 0 : slider.addEventListener('mousemove', mouseMove);
        return function () {
            slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mousedown', mouseDown);
            slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mouseleave', mouseLeave);
            slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mouseup', mouseUp);
            slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mousemove', mouseMove);
        };
    }, [container, enabled]);
}
export default useScrollDrag;
